import { IconProps } from "@radix-ui/react-icons/dist/types";
import * as React from "react";

export const SignInIcon = React.memo(function SignInIcon({
  color = "currentColor",
  ...props
}: IconProps) {
  return (
    <svg
      width="15"
      height="15"
      viewBox="0 0 15 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {/* Door/Bracket on the right */}
      <path d="M8.5 1.5H13.5V13.5H8.5" stroke={color} />
      {/* Arrow pointing right into the bracket */}
      <path
        d="M2.5 7.5H9.5M9.5 7.5L7.5 5.5M9.5 7.5L7.5 9.5"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
});
